/**
 * Notification bar
 */
var cor_banner = function() {

  var notifications = document.querySelectorAll('.js-notification');
  var root = document.getElementsByTagName('html')[0];

  for (var i = 0; i < notifications.length; i++) {

    var notification = notifications[i];
    notification.classList.add('notification--active');
    root.classList.add('notification-active');

  }

};

cor_banner();
